import React from 'react';
import { Img, Icon, Button } from 'components';
import { Section, Box, Text } from 'styles';

export function Section8({ setRef }) {
  return (
    <Section ref={setRef} $scrollMarginTop={91} $mScrollMarginTop={107}>
          <Box $maxWidth={1600} $padding="80px 40px" $mPadding="40px 20px" $margin="auto">
            <Box $width="fit-content" $margin="auto">
              <Button $type="badge">
                <Icon name="badgeIcon" />
                Pricing
              </Button>
            </Box>
            <Text $type="b40" $mType="b28" $padding="24px 0 16px" $textAlign="center">
              원하시는 서비스로 골라주세요
            </Text>
            <Text $type="18" $mType="16" $textAlign="center" $color="gray600">
              N-Survey는 조사 목적과 규모에 따라 합리적인 비용으로 유연하게 설계됩니다.
              <br />
              전통적인 시장조사 대비 낮은 비용으로 빠른 의사결정 검증이 가능합니다.
            </Text>
            <Box $margin="auto" $width="fit-content" $padding="64px 40px 80px" $mPadding="24px 0" $maxWidth={1600}>
              <Img desktopSrc="main8" mobileSrc="moMain8" $width="100%" />
            </Box>
      </Box>
    </Section>
  );
}